export default __webpack_public_path__ + "static/media/iconWishlist1.c2a0711c.svg";